import React from 'react';
import { Styles } from './styles';
import PriceBar from '@assets/images/green-price-tag.png';

interface PriceFlagProps {
  price: string;
  category: string;
  priceFontSize?: string;
  categoryFontSize?: string;
  marginVertical?: string;
  categoryMarginTop?: string;
  categoryMarginBottom?: string;
}
const PriceFlag: React.FC<PriceFlagProps> = ({
  price,
  category,
  priceFontSize = '27px',
  categoryFontSize = '14px',
  marginVertical = '-8px',
  categoryMarginTop = '-8px',
  categoryMarginBottom = '-8px'
}) => {
  const hasPricePrefix = price.includes('\n');
  const pricePrefix = hasPricePrefix ? price.split('\n')[0] : null;
  const priceValue = hasPricePrefix ? price.split('\n')[1] : price;

  return (
    <Styles.PriceContainer>
      {/* <Styles.PriceImage src={PriceBar} /> */}
      <Styles.TextContainer bgImg={PriceBar}>
        <Styles.CategoryText textSize={categoryFontSize}>
          {category}
        </Styles.CategoryText>
        {pricePrefix && (
          <Styles.PricePrefixText>{pricePrefix}</Styles.PricePrefixText>
        )}
        <Styles.PriceText
          textSize={priceFontSize}
          marginTop={pricePrefix ? '0' : categoryMarginTop}
          marginBottom={categoryMarginBottom}>
          {priceValue}
        </Styles.PriceText>
      </Styles.TextContainer>
    </Styles.PriceContainer>
  );
};
export default PriceFlag;
